<div class="w-full bg-white border-box radius-10 mb-20" [style.border]="isValidated ? '2px solid #28a745' : 'none'"
  style="border-radius: 10px;" id="contact-verif">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center">
      <div>
        <div class="flex gap-10 align-items-center mb-5">
          <img *ngIf="!isValidated" src="assets/square-icon.svg" alt="">
          <img *ngIf="isValidated" src="assets/valid-square-icon.svg" alt="" width="40px">
          <div>
            <p class="no-margin light-blue bold">5. Suivi en temps réel des votes</p>
            <p class="no-margin dark-gray text-sm">Observez l'enregistrement des votes en direct.</p>
          </div>
        </div>
      </div>
    </div>

  </div>


  <div class="p-20 align-items-end" style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px;">
    <div class="p-10 flex flex-column content-evenly text-center"
      style="border: solid 1px #DCEEFF; border-top: solid 3px #2B2D67;">
      <p class="dark-blue bold text-xl no-margin">{{assessorQuorum.voters}}</p>
      <p class="dark-blue text-md no-margin mt-10">ELECTEURS INVITÉS</p>
    </div>
    <div class="p-10 flex flex-column content-evenly text-center"
      style="border: solid 1px #DCEEFF; border-top: solid 3px #1990FF;">
      <p class="light-blue bold text-xl no-margin">{{assessorQuorum.votedVoters}}</p>
      <p class="light-blue text-md no-margin mt-10">VOTES ENREGISTRÉS</p>
    </div>
    <div class="p-10 flex flex-column content-evenly text-center"
      style="border: solid 1px #DCEEFF; border-top: solid 3px #32A24C;">
      <p class="no-margin text-xl bold strong-green">{{assessorQuorum.remainingVoters}}</p>
      <p class="no-margin text-md strong-green mt-10">VOTES RESTANTS</p>
    </div>

    <div class="radius-10">
      <p class="light-blue bold no-margin text-xs" style="width: fit-content;">Progression
        {{assessorQuorum.votedVoters}}/{{assessorQuorum.voters}}</p>
      <progress max="100" value="{{ (assessorQuorum.votedVoters / assessorQuorum.voters) * 100 | number:'1.0-0' }}"
        style="width: 100%;"> {{ assessorQuorum.votedVoters}}/{{assessorQuorum.voters}} * 100 </progress>
    </div>
  </div>
</div>